import React, { useState, useEffect } from "react";

import Select from "react-select";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from "react-redux";

// shadcn/ui components
import { Alert, AlertDescription } from "components/ui/alert";
import { Button } from "components/ui/button";

// Lucide icons
import { X, Building2 } from "lucide-react";

import {
    SG_GET_ORGANIZATION_SELECT,
    PULL_ORGANIZATION,
    GET_AM_ORGANIZATION,
} from "constants/actions";

const QUERY_PARAMS = "organization";

const OrganizationSelect = ({
  setResetPageLoad, 
  changeOrganizationId = false,
  handleOrganizationChange = false,
  handleResetQueryPArams = false
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    let organization_id = searchParams.get(QUERY_PARAMS);
   
    const newQueryParameters = new URLSearchParams();

    const [organizationId, setOrganizationId] = useState(false);
    const [organizationSelect, setOrganizationSelect] = useState([]);
    const [organizationSelected, setOrganizationSelected] = useState([]);
    const [organizationDetails, setOrganizationDetails] = useState(null);

    const { get_selectedOrg, get_organization_select } = useSelector(
        (state) => ({
            get_organization_select: state.organizations.organization_select,
            get_selectedOrg: state.selectedOrg,
        }),
        shallowEqual
    );

    useEffect(() => {
        dispatch({
            type: SG_GET_ORGANIZATION_SELECT
        });
        if (organizationId > 0) {
            dispatch({
                type: PULL_ORGANIZATION,
                payload: { id: organizationId }
            });
        }
    }, [dispatch, organizationId]);

    useEffect(() => {
      if (organization_id) {
        setOrganizationId(organization_id);
      } else {
        setOrganizationId(get_selectedOrg?.organization?.id);
      }
      setOrganizationDetails(get_selectedOrg?.organization);
    }, [organization_id, get_selectedOrg]);

    useEffect(() => {
        setOrganizationSelect(get_organization_select);
        if (organizationId !== organizationSelected) {
            setOrganizationSelected(get_organization_select.filter(
                org => org.id === Number(organizationId))?.[0]);
        }
    }, [get_organization_select, organizationId, organizationSelected]);

    useEffect(() => {
        setOrganizationDetails(get_selectedOrg?.organization);
    }, [get_selectedOrg]);

    function ResetOrganization() {
      if (handleResetQueryPArams) {
        handleResetQueryPArams();
      }
      dispatch({
          type: GET_AM_ORGANIZATION,
          payload: null
      });
      if (changeOrganizationId) {
        changeOrganizationId(null);
      }
      navigate(`${window.location.pathname}`);
      setResetPageLoad(Math.round((new Date()).getTime() / 1000));
    }

    function ChangedOrganization(e) {
      if (handleOrganizationChange) {
        handleOrganizationChange(e?.id);
      }
        dispatch({
            type: GET_AM_ORGANIZATION,
            payload: e
        });
        newQueryParameters.set(QUERY_PARAMS, e.id);
        setSearchParams(newQueryParameters);
        setResetPageLoad(Math.round((new Date()).getTime() / 1000));
        if (changeOrganizationId) {
          changeOrganizationId(e.id);
        }
    }

    return (
        <div className="mb-6">
            {organizationDetails?.id ? (
                <Alert className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Building2 className="h-4 w-4" />
                        <AlertDescription>
                            <span className="font-semibold">
                                {organizationDetails?.id} {organizationDetails?.name}
                            </span>
                            {" "}
                            <span className="text-muted-foreground">
                                Close this to reset the organization or select another one.
                            </span>
                        </AlertDescription>
                    </div>
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={ResetOrganization}
                        className="h-8 w-8"
                    >
                        <X className="h-4 w-4" />
                    </Button>
                </Alert>
            ) : (
                <div className="relative z-[999]">
                    <Select
                        name="survey_preference"
                        options={organizationSelect}
                        onChange={ChangedOrganization}
                        getOptionLabel={(option) => `${option.id} # ${option.name}`}
                        getOptionValue={(option) => `${option.id}`}
                        value={organizationSelected}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select an organization..."
                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        maxMenuHeight={440}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default OrganizationSelect;
